import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AITaggingMock } from "../../../components/Mockups/AITaggingMock";

export const AITagging = () => {
  const { t } = useTranslation();
  return (
    <section id="smart-tagging" className="container section-padding pb-0">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 col-12">
          <div className="d-flex flex-column gap-2 mb-4">
            <h3 className="mb-0 fs-2 fw-bold">{t("home.aiTagging.title")}</h3>
            <div className="mt-3">
              <div className="d-flex align-items-center gap-3 mb-2">
                <i className="bi bi-robot fs-2 text-success"></i>
                <h4 className="fs-4 mb-0 fw-semibold">
                  {t("home.aiTagging.automatic.title")}
                </h4>
              </div>
              <p className="mb-0">
                {t("home.aiTagging.automatic.description")}
              </p>
            </div>
            <div className="mt-3">
              <div className="d-flex align-items-center gap-3 mb-2">
                <i className="bi bi-tags fs-2 text-success"></i>
                <h4 className="fs-4 mb-0 fw-semibold">
                  {t("home.aiTagging.consistent.title")}
                </h4>
              </div>
              <p className="mb-0">
                {t("home.aiTagging.consistent.description")}
              </p>
            </div>
          </div>
          <div className="mb-4 mb-lg-0">
            <Link
              to="/features/ai-tagging"
              className="btn btn-none text-success p-0 d-inline-flex align-items-center gap-2"
            >
              {t("features.buttons.aiTagging")}
            </Link>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-12">
          <div className="d-flex bg-success-subtle justify-content-center p-3 p-md-4 rounded-4 ms-0 ms-lg-4">
            <AITaggingMock />
          </div>
        </div>
      </div>
    </section>
  );
};
